var _path, _g, _path2, _g2, _path3, _ellipse, _ellipse2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 262,
    viewBox: "0 0 323 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.628 34.6752C248.57 41.3115 273.371 55.5215 285.196 78.45C297.252 101.825 295.36 130.861 285.863 155.348C277.144 177.826 256.849 193.15 236.002 205.284C218.386 215.537 197.572 213.499 177.745 218.276C153.561 224.102 130.095 246.13 107.214 236.31C84.4967 226.56 81.8983 195.753 72.266 173.005C62.8596 150.791 49.7181 129.461 51.8035 105.45C54.0478 79.609 61.4844 49.4956 84.0973 36.78C106.619 24.1156 133.499 45.3591 159.36 44.9691C181.603 44.6335 202.121 28.953 223.628 34.6752Z",
    fill: "#E1E8FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3165_189882)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.8398,
    y: 70.2749,
    width: 172.65,
    height: 147.711,
    rx: 9.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.0648,
    y: 71.4999,
    width: 170.2,
    height: 145.261,
    rx: 8.575,
    stroke: "#577FFE",
    strokeWidth: 2.45
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0648 80.0749C77.0648 75.3391 80.904 71.4999 85.6398 71.4999H238.69C243.425 71.4999 247.265 75.3391 247.265 80.0749V93.029H77.0648V80.0749Z",
    fill: "#E1E8FD",
    stroke: "#577FFE",
    strokeWidth: 2.45
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3165_189882)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.8398,
    y: 70.2749,
    width: 172.65,
    height: 147.711,
    rx: 9.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.0648,
    y: 71.4999,
    width: 170.2,
    height: 145.261,
    rx: 8.575,
    stroke: "#577FFE",
    strokeWidth: 2.45
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0648 80.0749C77.0648 75.3391 80.904 71.4999 85.6398 71.4999H238.69C243.425 71.4999 247.265 75.3391 247.265 80.0749V93.029H77.0648V80.0749Z",
    fill: "#E1E8FD",
    stroke: "#577FFE",
    strokeWidth: 2.45
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.88,
    cy: 126.866,
    rx: 3.83665,
    ry: 3.83667,
    fill: "#577FFE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.491,
    cy: 126.866,
    rx: 3.83665,
    ry: 3.83666,
    fill: "#577FFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.881 177.293V177.293C145.776 162.543 175.871 162.223 200.075 176.46L201.492 177.293",
    stroke: "#577FFE",
    strokeWidth: 1.8375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.086 172.023C119.69 173.123 123.1 176.477 123.913 181.089",
    stroke: "#577FFE",
    strokeWidth: 2.45,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.874 171.786C203.373 173.022 200.268 176.661 199.861 181.326",
    stroke: "#577FFE",
    strokeWidth: 2.45,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.243 65.479L268.631 51.0916",
    stroke: "#FE6968",
    strokeWidth: 2.45,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M273.427 83.7034H256.162",
    stroke: "#FE6968",
    strokeWidth: 2.45,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.061 63.5609V46.2959",
    stroke: "#FE6968",
    strokeWidth: 2.45,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0828 146.529C55.0828 149.104 52.9952 151.191 50.4199 151.191C47.8447 151.191 45.757 149.104 45.757 146.529C45.757 143.953 47.8447 141.866 50.4199 141.866C52.9952 141.866 55.0828 143.953 55.0828 146.529Z",
    stroke: "#577FFE",
    strokeWidth: 1.225
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9424 187.293L64.2035 193.656L70.0828 193.884L64.3278 196.662L61.9424 202.64L60.0116 196.661L55.6953 195.273L60.0116 193.883L61.9424 187.293Z",
    fill: "#577FFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M265.869 158.518L269.035 167.268L277.265 167.58L269.208 171.4L265.869 179.62L263.166 171.4L257.123 169.49L263.166 167.579L265.869 158.518Z",
    fill: "#577FFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M264.39 111.332L264.272 116.009L268.205 117.783L263.575 117.957L260.403 121.101L260.645 116.76L258.075 114.68L261.367 114.992L264.39 111.332Z",
    fill: "#577FFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6262 94.6012L61.8384 97.8593L64.1066 99.4072L61.0926 99.1652L58.5666 101.113L59.3835 98.0993L58.0415 96.4445L60.1184 96.9205L62.6262 94.6012Z",
    fill: "#577FFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3165_189882",
    x: 56.2398,
    y: 60.4749,
    width: 211.85,
    height: 186.911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3165_189882"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.45
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.45
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3165_189882",
    result: "effect2_dropShadow_3165_189882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3165_189882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3165_189882",
    x: 56.2398,
    y: 60.4749,
    width: 211.85,
    height: 186.911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3165_189882"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.45
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.45
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3165_189882",
    result: "effect2_dropShadow_3165_189882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3165_189882",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/EmptyState.cab49581d2413bec553fbc7c5cfcdb5f.svg";
export { ForwardRef as ReactComponent };